// Apply a leaf mark across the current selection in a SINGLE pass.
//
// Plate's generated per-mark transforms (editor.tf.fontSize.addMark,
// .color.addMark, .fontFamily.addMark, …) all route through core `addMarks`,
// which runs removeMarks([key]) THEN addMark(key, value) — two split-and-set
// passes over every text leaf in the selection. On large selections that
// doubles the immutable-tree mutations and the dirty-path set the normalizer
// then walks, which is the visible lag when restyling a big selection.
//
// A direct editor.tf.addMark(key, value) overwrites the mark in ONE pass with
// an identical result (collapsed selections still set the pending mark for the
// next typed character). Falls back to the plugin transform if core addMark is
// unavailable for any reason.
export function applyMarkFast(editor: any, key: string, value: string | null | undefined, pluginAddMark?: (v: string) => void): void {
    if (value == null || value === '') return;
    if (typeof editor?.tf?.addMark === 'function') {
        editor.tf.addMark(key, value);
    } else {
        pluginAddMark?.(value);
    }
}
